import Stepper, { Step, orientations } from "./StepIndicator";

export default Stepper;
export { Step, orientations };
